var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDate(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.897 2.799H3.103A2.11 2.11 0 001 4.917v15.965A2.11 2.11 0 003.103 23h17.794A2.11 2.11 0 0023 20.882V4.917a2.11 2.11 0 00-2.103-2.118z",
    fill: "#E69B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.998 5.79v15.092c0 .562-.221 1.1-.616 1.498-.394.397-.929.62-1.487.62H4.294l-1.61-1.834 15.571-10.391 2.733-6.46 2.01 1.475z",
    fill: "#BF8055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.186 4.058H3.822c-.778 0-1.408.634-1.408 1.418v14.848c0 .783.63 1.418 1.408 1.418h16.364c.777 0 1.408-.635 1.408-1.418V5.476c0-.784-.63-1.418-1.408-1.418z",
    fill: "#FAFEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.822 4.058h16.36a1.4 1.4 0 01.995.415 1.42 1.42 0 01.412 1.003v3.057H2.414V5.48a1.427 1.427 0 01.41-1.006 1.408 1.408 0 01.998-.416z",
    fill: "#57D957"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.198 7.695c.841 0 1.523-.686 1.523-1.533 0-.847-.682-1.533-1.523-1.533-.84 0-1.522.686-1.522 1.533 0 .847.681 1.533 1.522 1.533zM17.804 7.695c.84 0 1.522-.686 1.522-1.533 0-.847-.682-1.533-1.522-1.533-.841 0-1.523.686-1.523 1.533 0 .847.682 1.533 1.523 1.533z",
    fill: "#FAFEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.201 1h-.004a.782.782 0 00-.779.784V6.41c0 .433.349.785.779.785H6.2c.43 0 .779-.352.779-.785V1.784A.782.782 0 006.201 1zM17.803 1h-.005a.782.782 0 00-.778.784V6.41c0 .433.348.785.778.785h.005c.43 0 .778-.352.778-.785V1.784A.782.782 0 0017.803 1z",
    fill: "#385666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 20.896c3.16 0 5.72-2.58 5.72-5.76 0-3.182-2.56-5.761-5.72-5.761-3.159 0-5.72 2.579-5.72 5.76 0 3.182 2.561 5.76 5.72 5.76z",
    fill: "#57D957"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 18.037l-1.926-1.94a.887.887 0 01-.193-.97.886.886 0 01.479-.483.874.874 0 01.963.194l1.184 1.192a.596.596 0 00.845 0l3.238-3.248a.879.879 0 011.442.288.891.891 0 01-.192.97l-3.96 3.988a1.32 1.32 0 01-1.447.3 1.32 1.32 0 01-.432-.291z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgDate;